var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-spinner',{staticClass:"v-ext-display-loading",attrs:{"size":"20","line-fg-color":"var(--lighter-gray)","line-bg-color":"var(--lightest-gray)"}})}
var staticRenderFns = []

export { render, staticRenderFns }